import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { FontSizes } from '../Theme';

const Drawer = ({ alignRight, children, footer, onClose, show, title, wide }) => {
  const styles = {
    scrim: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      background: 'rgba(0,0,0,0.5)',
      zIndex: show ? 200 : -1,
      opacity: show ? 1 : 0,
      transition: 'all .3s'
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      position: 'fixed',
      left: alignRight ? null : 0,
      right: alignRight ? 0 : null,
      top: 0,
      bottom: 0,
      background: '#fff',
      zIndex: 200,
      width: wide ? 800 : 500,
      boxShadow: '0px -2px 20px 15px rgba(0,0,0,0.1)',
      transition: 'all .3s',
      transform: alignRight
        ? `translateX(${show ? '0%' : '120%'})`
        : `translateX(${show ? '0%' : '-120%'})`
    },
    innerContent: {
      overflow: 'auto',
      flex: 1
    },
    footer: {
      padding: '20px 30px',
      display: 'flex'
    },
    close: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: 29,
      right: alignRight ? null : -50,
      left: alignRight ? -50 : null,
      background: '#fff',
      width: 50,
      height: 52,
      borderRadius: alignRight ? '26px 0 0 26px' : '0 26px 26px 0',
      paddingRight: 4,
      cursor: 'pointer',
      flexShrink: 0
    },
    title: {
      fontSize: FontSizes.XLARGE,
      lineHeight: '1.3em',
      position: 'sticky',
      top: 0,
      background: '#fff',
      padding: 30,
      zIndex: 2
    }
  };

  useEffect(() => {
    if (show) {
      document.body.classList.add('ixn-no-scroll');

      document.onkeydown = e => {
        if (e.key === 'Escape') {
          onClose();
        }
      };
    }

    return () => {
      document.body.classList.remove('ixn-no-scroll');
      document.onkeydown = null;
    };
  }, [show]);

  return (
    <>
      <div onClick={onClose} style={styles.scrim} />
      <div style={styles.content}>
        {show ? (
          <>
            <div onClick={onClose} style={styles.close}>
              <i className='mdi mdi-close' style={{ fontSize: 24 }} />
            </div>
            <div style={styles.innerContent}>
              {title ? <div style={styles.title}>{title}</div> : null}

              <div style={{ padding: 30 }}>{children}</div>
            </div>
            <div style={styles.footer}>{footer}</div>
          </>
        ) : null}
      </div>
    </>
  );
};

Drawer.propTypes = {
  alignRight: PropTypes.bool,
  footer: PropTypes.node,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  wide: PropTypes.bool
};

export default Drawer;
